module.exports = __webpack_public_path__ + "assets/RU.1f87cf61aed8f3fb69f2f203a2170e80.png";